import React, {PureComponent} from "react"

import {Reward} from "@irati/types"
import getId from "@irati/utils/id"

import {DetailsWrapper, Title} from "./styled/Details"

interface Props {
  id: string
  reward: Reward
}

export default class DetailsComponent extends PureComponent<Props> {
  render() {
    const {id, reward} = this.props

    return (
      <DetailsWrapper id={id}>
        <Title id={getId("title", this.props)}>{reward.header}</Title>
      </DetailsWrapper>
    )
  }
}
